import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const reportSchedulersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EVENTS_BY_GROUP_REPORT_SUCCESS:
            return {
                ...state,
                refDataEventsByGroup: action.payload,
            };
        case actionTypes.GET_EVENTS_BY_EACH_GROUP_REPORT_SUCCESS:
            return {
                ...state,
                refDataEventsByGroupSingle: {
                    ...state.refDataEventsByGroupSingle,
                    [action.payload.reportRefId]: action.payload.data,
                },
            };
        case actionTypes.SET_EVENTS_BY_EACH_GROUP_REPORT_SUCCESS:
            return {
                ...state,
                refDataEventsByGroupSingle: action.payload,
            };
        default:
            return state;
    }
};

export default reportSchedulersReducer;
